export const mainBantuanNavMenus = [
  {
    title: "FAQ",
    path: "/faq"
  },
  {
    title: "Kritik dan Saran",
    path: "/kritik-saran"
  },
  {
    title: "Denah",
    path: "/denah"
  },
  {
    title: "Rekomendasi",
    path: "/rekomendasi"
  }
];